import React from 'react';
import { CheckCircle, Calendar, Folder, Trophy, Tv, TvMinimalPlay, Handshake } from 'lucide-react';

export const TEST_FOLDER_ICONS: Record<string, React.ReactNode> = {
  // DISNEY
  'available-now': <CheckCircle size={12} />,
  ctv: <Tv size={12} />,
  espn: <Trophy size={12} />,
  'seasonality-300x600': <Calendar size={12} />,

  // RESUMIDO
  generico: <TvMinimalPlay size={12} />,
  'mano-a-mano': <Handshake size={12} />,

  // GPOVALLAS
  'auto-resolution': <Tv size={12} />,
  'auto-resolution-branded': <Tv size={12} />
};

export const getTestFolderIcon = (sk: string): React.ReactNode => {
  return TEST_FOLDER_ICONS[sk] || <Folder size={12} />;
};
